import { PropsWithChildren } from 'react'

type EntryBoxProps = PropsWithChildren<{ className?: string }>

export default function EntryBox(props: EntryBoxProps) {
  return <div className={props.className}>{props.children}</div>
}
